import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { API } from '../../config';
import { useDashboardSelection } from '../../dashboardSelection';

const wrap = { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'nowrap' };
const sel = { padding: '4px 7px', border: '1px solid #cbd5e1', borderRadius: 7, fontSize: 12, maxWidth: 210, color: '#334155' };
const sbtn = { padding: '4px 9px', fontSize: 12, borderRadius: 7, border: '1px solid #cbd5e1', background: 'var(--surface)', cursor: 'pointer', color: '#334155', whiteSpace: 'nowrap' };
const pbtn = { ...sbtn, background: '#4895ef', color: '#fff', border: '1px solid #4895ef' };
const dis = { opacity: 0.5, cursor: 'default' };

export default function SavedViews() {
  const { selRegions, setSelRegions, selProvinces, setSelProvinces } = useDashboardSelection();
  const navigate = useNavigate();
  const [aree, setAree] = useState([]);
  const [scelta, setScelta] = useState('');

  const load = useCallback(() => {
    axios.get(`${API}/export/gruppi`).then((r) => setAree(r.data.items || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const applica = () => {
    const v = aree.find((x) => x.id === scelta);
    if (!v) return;
    setSelRegions(new Set(v.regioni || []));
    setSelProvinces(new Set(v.province || []));
    toast.success(`"${v.nome}" applicata sulla mappa`);
  };

  const esporta = () => {
    const v = aree.find((x) => x.id === scelta);
    if (!v) return;
    navigate('/export', { state: { exportSel: { regioni: v.regioni || [], province: v.province || [] } } });
  };

  const salva = async () => {
    const nome = window.prompt('Nome delle aree salvate (es. "Contact Pisa"):');
    if (!nome || !nome.trim()) return;
    try {
      await axios.post(`${API}/export/gruppi`, {
        nome: nome.trim(), regioni: [...selRegions], province: [...selProvinces],
      });
      toast.success(`Aree salvate "${nome.trim()}"`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore salvataggio'); }
  };

  const elimina = async () => {
    const v = aree.find((x) => x.id === scelta);
    if (!v) return;
    if (!window.confirm(`Eliminare "${v.nome}"?`)) return;
    try { await axios.delete(`${API}/export/gruppi/${v.id}`); setScelta(''); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  const nSel = selRegions.size + selProvinces.size;

  return (
    <div style={wrap}>
      <span style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Aree salvate</span>
      <select style={sel} value={scelta} onChange={(e) => setScelta(e.target.value)}>
        <option value="">— scegli —</option>
        {aree.map((v) => (
          <option key={v.id} value={v.id}>
            {v.nome} ({(v.regioni || []).length}R · {(v.province || []).length}P)
          </option>
        ))}
      </select>
      <button style={scelta ? sbtn : { ...sbtn, ...dis }} onClick={applica} disabled={!scelta}>Applica</button>
      <button style={scelta ? sbtn : { ...sbtn, ...dis }} onClick={esporta} disabled={!scelta}>Esporta</button>
      <button style={scelta ? { ...sbtn, color: '#b91c1c' } : { ...sbtn, ...dis }} onClick={elimina} disabled={!scelta}>Elimina</button>
      <button style={nSel ? pbtn : { ...pbtn, ...dis }} onClick={salva} disabled={nSel === 0} title="Salva la selezione corrente">
        Salva selezione{nSel ? ` (${nSel})` : ''}
      </button>
    </div>
  );
}
